import defaultConfig from '../config/default.json';
import readClientConfiguration from './readClientConfiguration';

const countryCode = readClientConfiguration(defaultConfig, 'countryCode');

export const isHR = countryCode === 'hr-HR';
export const isRS = countryCode === 'rs-RS';
export const isSI = countryCode === 'sl-SI';
